var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["events/js/templates/calendar.nunjucks"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "weekdays");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("weekday", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        <li class=\"header\">";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "</li>\n";
;
}
}
frame = frame.pop();
output += "\n";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "days");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("day", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n        <li class=\"";
if(t_8) {
output += "day";
;
}
if(runtime.memberLookup((t_8),"events")) {
output += " mark";
;
}
if(runtime.memberLookup((t_8),"current")) {
output += " current";
;
}
output += "\">\n                ";
if(t_8) {
output += "\n                    ";
if(runtime.memberLookup((t_8),"current") || !runtime.memberLookup((t_8),"events")) {
output += "\n                        ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"day"), env.opts.autoescape);
output += "\n                    ";
;
}
else {
output += "\n                        <a href=\"#\"\n                           data-day=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"day"), env.opts.autoescape);
output += "\"\n                           data-month=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"month"), env.opts.autoescape);
output += "\"\n                           data-year=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"year"), env.opts.autoescape);
output += "\"\n                        >\n                            ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"day"), env.opts.autoescape);
output += "\n                        </a>\n                    ";
;
}
output += "\n                ";
;
}
output += "\n        </li>\n";
;
}
}
frame = frame.pop();
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["events/js/templates/calendar.nunjucks"] , dependencies)